import { render, staticRenderFns } from "./4mRiskRegisterTL.vue?vue&type=template&id=1fc7e6b0"
import script from "./4mRiskRegisterTL.vue?vue&type=script&lang=js"
export * from "./4mRiskRegisterTL.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1fc7e6b0')) {
      api.createRecord('1fc7e6b0', component.options)
    } else {
      api.reload('1fc7e6b0', component.options)
    }
    module.hot.accept("./4mRiskRegisterTL.vue?vue&type=template&id=1fc7e6b0", function () {
      api.rerender('1fc7e6b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ram/4m/timeline/4mRiskRegisterTL.vue"
export default component.exports